export const FlatListDraggable = () => {
    throw new Error("FlatListDraggable is not currently supported for web. ");
};
export const ScaleDragDecorator = () => {
    throw new Error("ScaleDragDecorator is not currently supported for web. ");
};
